import React, { useEffect, useState } from "react";
import Top_bar from "../../Components/topBar/topBar";
import BottomBar from "../../Components/bottomBar/bottomBar";
import DonutChart from "../../Components/donutChart/donutChart";
import styles from "./details.module.css";
import configUrl from "../../services/configUrl";
import { useLocation } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import io from "socket.io-client";
import api from "../../services/api";
//import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

/*import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  Legend,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";*/

//import Select from "../../Components/select/select";
//import { Col, Row } from "react-bootstrap";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Details() {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);
  const [selectedWeek, setSelectedWeek] = useState(new Date());

  const handleChangeDate = ([newStartDate, newEndDate]) => {
    setStartDate(newStartDate);
    setEndDate(newEndDate);
  };

  const query = useQuery();
  const [loading, setLoading] = useState(true);
  const [loadingDetails, setLoadingDetails] = useState(true);
  const [namespace, setNamespace] = useState();
  const [details, setDetails] = useState();
  const [colorOee, setColorOee] = useState();
  const [colorDisp, setColorDisp] = useState();
  const [colorQual, setColorQual] = useState();
  const [colorPerf, setColorPerf] = useState();
  const [verify, setVerify] = useState(false);

  useEffect(() => {
    const getOEEDetails = async () => {
      try {
        api
          .get("/machines/oee-details/", {
            params: { id_machine: query.get("id_machine") },
          })
          .then((resp) => {
            if (loading) setLoading(false);

            setNamespace(resp.data);
            handleColor(
              namespace?.oee,
              namespace?.disponibility,
              namespace?.performance,
              namespace?.quality,
              namespace?.orderPerformance
            );
          });
      } catch (error) {
        //alert(error)
      }
    };
    getOEEDetails();
  }, []);

  useEffect(() => {
    const getDetails = async () => {
      try {
        const response = await api.get(
          `/machines/detail/${query.get("id_machine")}`
        );

        if (response.data) {
          console.log(response.data);
          setDetails(response.data);
          setLoadingDetails(false);
        }
      } catch (error) {
        //alert(error);
      }
    };
    let socket = io(
      `${configUrl.protocol}://${configUrl.ip}
      /machine-${query.get("id_machine")}`
    );

    socket.on("reply-namespace", (data) => {
      setNamespace(data);
      if (loading) setLoading(false);
    });
    getDetails();
    handleColor(
      namespace?.oee,
      namespace?.disponibility,
      namespace?.performance,
      namespace?.quality,
      namespace?.orderPerformance
    );
    return () => {
      socket.removeAllListeners();
      socket = null;
    };
  }, [
    namespace?.oee,
    namespace?.disponibility,
    namespace?.performance,
    namespace?.quality,
    namespace?.orderPerformance,
  ]);

  const oeecolorchart = (variable, colorValue) => {
    const color1 = "#ff0000";
    const color2 = "#ffd966";
    const color3 = "#ffc000";
    const color4 = "#2e75b6";
    const color5 = "#a9d18e";
    const color6 = "#548235";
    if (variable < 25.0) {
      if (colorValue === 0) {
        setColorOee(color1);
      } else if (colorValue === 1) {
        setColorDisp(color1);
      } else if (colorValue === 2) {
        setColorPerf(color1);
      } else if (colorValue === 3) {
        setColorQual(color1);
      } else if (colorValue === 4) {
        setColorPerfOrd(color1);
      }
    } else if (variable > 25.0 && variable < 40.0) {
      if (colorValue === 0) {
        setColorOee(color2);
      } else if (colorValue === 1) {
        setColorDisp(color2);
      } else if (colorValue === 2) {
        setColorPerf(color2);
      } else if (colorValue === 3) {
        setColorQual(color2);
      } else if (colorValue === 4) {
        setColorPerfOrd(color2);
      }
    } else if (variable > 40.0 && variable < 55.0) {
      if (colorValue === 0) {
        setColorOee(color3);
      } else if (colorValue === 1) {
        setColorDisp(color3);
      } else if (colorValue === 2) {
        setColorPerf(color3);
      } else if (colorValue === 3) {
        setColorQual(color3);
      } else if (colorValue === 4) {
        setColorPerfOrd(color3);
      }
    } else if (variable > 55.0 && variable < 70.0) {
      if (colorValue === 0) {
        setColorOee(color4);
      } else if (colorValue === 1) {
        setColorDisp(color4);
      } else if (colorValue === 2) {
        setColorPerf(color4);
      } else if (colorValue === 3) {
        setColorQual(color4);
      } else if (colorValue === 4) {
        setColorPerfOrd(color4);
      }
    } else if (variable > 70.0 && variable < 85.0) {
      if (colorValue === 0) {
        setColorOee(color5);
      } else if (colorValue === 1) {
        setColorDisp(color5);
      } else if (colorValue === 2) {
        setColorPerf(color5);
      } else if (colorValue === 3) {
        setColorQual(color5);
      } else if (colorValue === 4) {
        setColorPerfOrd(color5);
      }
    } else if (variable > 85.0) {
      if (colorValue === 0) {
        setColorOee(color6);
      } else if (colorValue === 1) {
        setColorDisp(color6);
      } else if (colorValue === 2) {
        setColorPerf(color6);
      } else if (colorValue === 3) {
        setColorQual(color6);
      } else if (colorValue === 4) {
        setColorPerfOrd(color6);
      }
    }
    setVerify(true);
  };
  const handleColor = (oee, disp, perf, qual, perf_ord) => {
    oeecolorchart(oee, 0);
    oeecolorchart(disp, 1);
    oeecolorchart(perf, 2);
    oeecolorchart(qual, 3);
    oeecolorchart(perf_ord, 4);
  };

  const optionsFilter = [
    { value: "month", label: "Meses" },
    { value: "year", label: "Anos" },
    { value: "week", label: "Semanas" },
  ];

  const getPlaceholder = () => {
    if (filter === "month") return "Meses";
    if (filter === "year") return "Anos";
    if (filter === "week") return "Semanas";
  };

  const dataChart = [
    { name: "Janeiro", Produzindo: 70, Parado: 10, tipo: "month" },
    { name: "Fevereiro", Produzindo: 25, Parado: 15, tipo: "month" },
    { name: "Segunda", Produzindo: 8, Parado: 2, tipo: "week" },
    { name: "Terça", Produzindo: 10, Parado: 5, tipo: "week" },
    { name: "Quarta", Produzindo: 10, Parado: 5, tipo: "week" },
    { name: "Quinta", Produzindo: 10, Parado: 5, tipo: "week" },
    { name: "Sexta", Produzindo: 10, Parado: 5, tipo: "week" },
    { name: "2002", Produzindo: 12, Parado: 13, tipo: "year" },
    { name: "2003", Produzindo: 12, Parado: 13, tipo: "year" },
    { name: "2004", Produzindo: 12, Parado: 13, tipo: "year" },
  ];

  const [filter, setFilter] = useState("year");

  const dataFilter = dataChart.filter((item) => item.tipo === filter);

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div
          style={{
            backgroundColor: "#fff",
            padding: "8px",
            border: "1px solid #ccc",
          }}
        >
          <p style={{ margin: 0, fontWeight: "bold" }}>{label}</p>
          {payload.map((item, index) => (
            <p key={index} style={{ margin: 0, color: item.color }}>
              {item.name}: {item.value}%
            </p>
          ))}
        </div>
      );
    }

    return null;
  };

  return (
    <>
      <Top_bar />
      <main className={styles.container}>
        <section>
          <div className={styles.card}>
            <span>Máquina</span>
            <strong>{details?.machine || "---"}</strong>
          </div>
          <div className={styles.card}>
            <span>Setor</span>
            <strong>{details?.department || "---"}</strong>
          </div>
          <div className={styles.card}>
            <span>Operador</span>
            <strong>{details?.operator || "---"}</strong>
          </div>
          <div className={styles.card}>
            <span>Turno</span>
            <strong>
              {details?.work_shift +
                " " +
                details?.start_time +
                " - " +
                details?.end_time || "---"}
            </strong>
          </div>
          <div className={styles.card}>
            <span>Ordem - Item</span>
            <strong>{details?.production_order || "---"}</strong>
          </div>
          <div className={styles.card}>
            <span>Operação - Alternativa </span>
            <strong>{details?.operation || "---"}</strong>
          </div>
          <div className={styles.card}>
            <span>Total produzido dia</span>
            <strong>{details?.productionDay || 0} {details?.unit || `pçs.`}</strong>
          </div>
          <div className={styles.card}>
            <span>Total produzido turno</span>
            <strong>{details?.productionWorkShift || 0} {details?.unit || `pçs.`}</strong>
          </div>
          <div className={styles.card}>
            <span>Total produzido ordem</span>
            <strong>{details?.produced || 0} {details?.unit ||  `pçs.`}</strong>
          </div>
          <div className={styles.card}>
            <span>Total refugado dia</span>
            <strong>{details?.scrapDay || 0} {details?.unit || `pçs.`}</strong>
          </div>
          <div className={styles.card}>
            <span>Total refugado turno</span>
            <strong>{details?.scrapWorkShift || 0} {details?.unit || `pçs.`}</strong>
          </div>
          <div className={styles.card}>
            <span>Total refugado ordem</span>
            <strong>{details?.refuse || 0} {details?.unit || `pçs.`}</strong>
          </div>

          {loading ? (
            <div
              style={{ marginTop: "20vh", marginLeft: "42vw" }}
              className={styles.loader}
            >
              <Spinner variant="success" animation="border" />
              <strong>Carregando...</strong>
            </div>
          ) : (
            <>
              <div
                className={`containerDetailsGraphics ${styles.card} ${styles.oee} `}
              >
                <span id={`${styles.oeetitle}`}>
                  <strong>OEE Turno</strong>
                </span>
                <DonutChart
                  id="oee_turno"
                  color={verify ? colorOee : "transparent"}
                  className={styles.donut}
                  value={namespace?.oee || 0}
                  valuelabel="OEE"
                />
                <DonutChart
                  id="disponibilidade"
                  color={verify ? colorDisp : "transparent"}
                  className={styles.donut}
                  value={namespace?.disponibility || 0}
                  valuelabel="Disponibilidade"
                />
                <DonutChart
                  id="performance"
                  color={verify ? colorPerf : "transparent"}
                  className={styles.donut}
                  value={namespace?.performance || 0}
                  valuelabel="Performance"
                />
                <DonutChart
                  id="Qualidade"
                  color={verify ? colorQual : "tranparent"}
                  className={styles.donut}
                  value={namespace?.quality || 0}
                  valuelabel="Qualidade"
                />
              </div>
              <div className={`${styles.card} ${styles.order}`}>
                {/*< span>Tempo Parado</span>
                <strong>{details?.produced || 0}{' '}Hrs.</strong> */}
                <span>Máq. Parada desde</span>
                <strong>{details?.stop_start_time || "---"} </strong>
                {/*  <DonutChart
                  id="performance_ordem"
                  color={verify ? colorPerfOrd : "tranparent"}
                  className={styles.donut}
                  value={namespace?.orderPerformance}
                  size={170}
                  valuelabel="Performance ordem"
                /> */}
              </div>
            </>
          )}
        </section>

        {/*<div className={styles.machineDashChart}>
          <Row className={styles.machineDashHeader}>
            <Col lg={4} xs={12} className="p-0">
              <h4>Status de Máquina</h4>
            </Col>
            <Col
              lg={6}
              xs={12}
              className="d-flex justify-content-end align-items-center p-0"
              style={{ width: "auto", gap: "5px" }}
            >
              <Row className="align-items-center" style={{ gap: "5px" }}>
                {" "}
                <Col lg={7} sm={7} xs={12} className="p-0">
                  {filter === "month" && (
                    <>
                      <DatePicker
                        className="insideDatePicker Inside"
                        showIcon
                        selected={startDate}
                        onChange={handleChangeDate}
                        selectsRange
                        startDate={startDate}
                        endDate={endDate}
                        dateFormat="MM/yyyy"
                        showMonthYearPicker
                      />
                    </>
                  )}
                  {filter === "year" && (
                    <DatePicker
                      className="insideDatePicker Inside"
                      showIcon
                      selected={startDate}
                      onChange={handleChangeDate}
                      selectsRange
                      startDate={startDate}
                      endDate={endDate}
                      dateFormat="yyyy"
                      showYearPicker
                      minDate={new Date("2000/01/01")}
                      maxDate={new Date()}
                    />
                  )}
                  {filter === "week" && (
                    <DatePicker
                      className="insideDatePicker Inside"
                      selected={selectedWeek}
                      onChange={(date) => setSelectedWeek(date)}
                      dateFormat="I/R"
                      locale="en-GB"
                      showWeekNumbers
                      showWeekPicker
                      showIcon
                    />
                  )}
                </Col>
                <Col lg={4} sm={3} xs={12} className="p-0">
                  <div className="element" style={{ width: "130px" }}>
                    <Select
                      arrData={optionsFilter}
                      selectedID={filter}
                      handleSelect={(value) => setFilter(value)}
                      autoSelect={false}
                      isDisabled={false}
                      placeHolder={getPlaceholder()}
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <div style={{ height: "300px" }}>
            <ResponsiveContainer width="100%" height="70%">
              <BarChart
                data={dataFilter}
                margin={{
                  top: 20,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" fontSize={"10px"} />
                <YAxis
                  fontSize={"10px"}
                  domain={[0, 100]}
                  tickFormatter={(value) => `${value}%`}
                />
                <Tooltip content={<CustomTooltip />} />
                <Legend />
                <Bar dataKey="Produzindo" fill="#4CAF50">
                  <LabelList datakey="Produzinho" position="top" />
                </Bar>
                <Bar dataKey="Parado" fill="#F44336" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>*/} 
      </main>
      {loading || loadingDetails ? (
        <BottomBar
          marginT={
            window.screen.width > 1024 && window.screen.width <= 1280
              ? "8%"
              : window.screen.width > 1280 && window.screen.width <= 1440
              ? "9.2%"
              : null
          }
        />
      ) : (
        <BottomBar
          marginT={
            window.screen.width > 1024 && window.screen.width <= 1280
              ? "12.9%"
              : window.screen.width > 1280 && window.screen.width <= 1440
              ? "6.5%"
              : null
          }
          position={"static"}
        />
      )}
    </>
  );
}

export default Details;
